/**
 * Salesforce Integration Enums
 *
 * Enums used across the Salesforce integration entities
 */

/**
 * Setup Status Enum
 * Tracks the progress of the Salesforce integration wizard setup
 */
export enum SetupStatus {
  CONNECTED = "CONNECTED",
  USERS_CONFIGURED = "USERS_CONFIGURED",
  ACCOUNTS_CONFIGURED = "ACCOUNTS_CONFIGURED",
  CONTACTS_CONFIGURED = "CONTACTS_CONFIGURED",
  FIELDS_MAPPED = "FIELDS_MAPPED",
  COMPLETED = "COMPLETED",
}

/**
 * Salesforce Connection Status
 * Whether Skrift may call Salesforce for this connection. SUSPENDED is set on a
 * terminal error (org inactive, token revoked) and cleared by a reconnect.
 */
export enum SalesforceConnectionStatus {
  ACTIVE = "active",
  SUSPENDED = "suspended",
}

/**
 * Why a Salesforce connection was suspended
 */
export enum SalesforceSuspensionReason {
  ORG_INACTIVE = "org_inactive",
  TOKEN_REVOKED = "token_revoked",
}

/**
 * Salesforce Sync Object Enum
 * Types of objects that can be synced from Salesforce
 */
export enum SFSyncObject {
  USER = "USER",
  ACCOUNT = "ACCOUNT",
  CONTACT = "CONTACT",
}

/**
 * Sync Config Status Enum
 * Status of sync configuration for a Salesforce object
 */
export enum SyncConfigStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

/**
 * Salesforce Object Name Enum
 * Salesforce object types that can have field mappings
 */
export enum SFObjectName {
  Account = "Account",
  Contact = "Contact",
  Users = "Users",
}

/**
 * Sync Job Type Enum
 * Types of sync jobs that can be executed
 */
export enum SyncJobType {
  USER_SYNC = "USER_SYNC",
  ACCOUNT_SYNC = "ACCOUNT_SYNC",
  CONTACT_SYNC = "CONTACT_SYNC",
  DEACTIVATION_SYNC = "DEACTIVATION_SYNC",
  CDC_SYNC = "CDC_SYNC",
  MERGE_SYNC = "MERGE_SYNC",
}

/**
 * Sync Status Enum
 * Status of a sync job execution
 */
export enum SyncStatus {
  STARTED = "STARTED",
  COMPLETED = "COMPLETED",
  COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
  FAILED = "FAILED",
}
